/**
 * @typedef {{red: number, green: number, blue: number}} RGBColor
 */
export const DEBUG = {
  // #636e72
  red: 99,
  green: 110,
  blue: 114,
};
export const INFO = {
  // #487eb0
  red: 72,
  green: 126,
  blue: 176,
};
export const LOG = {
  // #4cd137
  red: 76,
  green: 209,
  blue: 55,
};
export const WARN = {
  // #e1b12c
  red: 225,
  green: 177,
  blue: 44,
};
export const ERROR = {
  // #e74c3c
  red: 231,
  green: 76,
  blue: 60,
};
export const GROUP = {
  // #00a8ff
  red: 0,
  green: 168,
  blue: 255,
};
